<template>
    <div class="pt-8">
        <image-list-table 
            :imageList="imageList" 
            @open-add-modal="openModalNewImage($event)"
            @update-image-list="imageDeleted()"
        />

        <template v-if="newImageModal">
            <image-form-modal
            :newImageModal="newImageModal"
            :imageData="imageData"
            :optionsImage="optionsImage"
            @close-modal="newImageModal = false"
            @image-saved="imageSaved()"
            />
        </template>
    </div>
</template>
<script>
import ImageListTable from '../Components/ImageListTable.vue'
import ImageFormModal from '../Components/ImageFormModal.vue'
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            imageList: [],
            newImageModal: false,
            imageData: {
                sectionOption: '',
                orderOption: 0
            },
            optionsImage: []
        }
    },
    components: {
        ImageListTable,
        ImageFormModal
    },
    created(){
        this.getImageList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getImageList() {
            this.setLoading(true)
            await this.$conectar.post('admin/configuration/banner/get-image-list')
            .then(response =>{
                this.imageList = response.data.data;
                this.optionsImage = response.data.optionsImage;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        openModalNewImage(){
            this.newImageModal = true;
            this.imageData = {
                sectionOption: '',
                orderOption: 0
            };
        },
        imageSaved(){
            this.newImageModal = false;
            this.getImageList();
        },
        imageDeleted()
        {
            this.getImageList();
            this.$swal({
                position: 'top-end',
                icon: 'success',
                title: 'Imagen eliminada correctamente',
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            });
        }
    }
}
</script>

<style scoped>
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}
.singleLineTd td {
  white-space: nowrap !important;
  overflow: hidden !important;
}
</style>